import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";

const WELCOME_SHOWN_KEY = "ask4gems_welcome_shown";

/**
 * Shows a one-time welcome toast when a user first logs in
 * after email verification with their welcome bonus.
 */
const WelcomeBonusToast = () => {
  const { user, profile } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    if (!user || !profile) return;

    // Only show if email is confirmed and we haven't shown before
    if (!user.email_confirmed_at) return;

    const shownKey = `${WELCOME_SHOWN_KEY}_${user.id}`;
    if (localStorage.getItem(shownKey)) return;

    // Check if user has the welcome bonus (credits > 0 implies bonus was granted)
    if (profile.credits >= 20) {
      localStorage.setItem(shownKey, "true");
      toast({
        title: "Welcome to Ask4gems! 🎉",
        description: "20 credits have been added to your account.",
      });
    }
  }, [user, profile, toast]);

  return null;
};

export default WelcomeBonusToast;
